import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useEffect } from "react"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { AuthProvider, NurAdmin } from "@/auth/AuthProvider"
import { Rahmen } from "@/components/Rahmen"
import { TipProvider } from "@/components/Tooltip"
import { VerwaltungRahmen } from "@/components/VerwaltungRahmen"
import { IST_TERMINAL_HOST, TERMINAL_URL, VERWALTUNG_URL } from "@/lib/adressen"
import { DashboardPage } from "@/pages/DashboardPage"
import { SchichtPage } from "@/pages/SchichtPage"
import { StartPage } from "@/pages/StartPage"
import { StellenPage } from "@/pages/StellenPage"
import { TerminalApp } from "@/pages/terminal/TerminalApp"

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } })

function Weiter({ nach }: { nach: string }) {
  useEffect(() => {
    window.location.replace(nach)
  }, [nach])
  return null
}

/** Callback-Route existiert nur, damit der Router den Pfad kennt; den Token-Tausch macht der AuthProvider. */
function Callback() {
  return null
}

/**
 * Betriebstagebuch (btb.rmnc.app, lokal /terminal): das Terminal ist frei aufrufbar bis zur
 * Chipleser-Ansicht (Anmeldung per RFID, nicht über authentik); die Verwaltung darunter
 * braucht die authentik-Anmeldung mit der Rolle app:betriebstagebuch:admin.
 */
function Betriebstagebuch() {
  return (
    <Routes>
      <Route path="verwaltung/*" element={<AuthProvider><NurAdmin><VerwaltungRahmen /></NurAdmin></AuthProvider>} />
      <Route path="callback" element={<AuthProvider><Callback /></AuthProvider>} />
      <Route path="*" element={<TerminalApp />} />
    </Routes>
  )
}

/** ProDash: die Sammlung der Dashboards. Die Verwaltung des Betriebstagebuchs liegt nicht hier. */
function ProDash() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/callback" element={<Callback />} />
        <Route element={<Rahmen />}>
          <Route index element={<StartPage />} />
          <Route path="auswertungen/betriebstagebuch" element={<DashboardPage />} />
          <Route path="schicht" element={<SchichtPage />} />
          <Route path="stellen" element={<StellenPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TipProvider>
        <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
          {IST_TERMINAL_HOST ? (
            <Betriebstagebuch />
          ) : (
            <Routes>
              <Route path="/terminal/*" element={TERMINAL_URL ? <Weiter nach={TERMINAL_URL} /> : <Betriebstagebuch />} />
              {/* alte Lesezeichen: die Verwaltung ist umgezogen */}
              <Route path="/verwaltung/*" element={<Weiter nach={VERWALTUNG_URL} />} />
              <Route path="*" element={<ProDash />} />
            </Routes>
          )}
        </BrowserRouter>
      </TipProvider>
    </QueryClientProvider>
  )
}
